/* eslint-disable */
export function shirtImageSrc(teamId: number, goalkeeper = false): string {
  if (goalkeeper) {
    try {
      return require(`../assets/shirts/${teamId}_gk.png`)
    } catch {
      // fall through to outfield shirt if GK asset missing
    }
  }
  try {
    return require(`../assets/shirts/${teamId}.png`)
  } catch {
    return require('../assets/shirts/0.png')
  }
}
